import {
    SUMMARY_ALL,
    SUMMARY_DEFAULT,
    SUMMARY_OTHERS,
    SUMMARY_PROJECTS,
    SUMMARY_SELF_INTRODUCTION
} from "../../actions/path";
import {getConstantVersion} from "../../util/util";

const initialState = {
    currentPath: '/',
    exPath: '/',
}

export const pathReducers = (state = initialState, action) => {
    // 버전에 따라 router 분기
    if (getConstantVersion() === 1) {
        if (action?.type === SUMMARY_DEFAULT) {
            return  {
                currentPath: SUMMARY_DEFAULT,
                exPath: state.currentPath,
            }
        }
        if (action?.type === SUMMARY_SELF_INTRODUCTION) {
            return  {
                currentPath: SUMMARY_SELF_INTRODUCTION,
                exPath: state.currentPath,
            }
        }
        if (action?.type === SUMMARY_PROJECTS) {
            return {
                currentPath: SUMMARY_PROJECTS,
                exPath: state.currentPath,
            }
        }
        if (action?.type === SUMMARY_OTHERS) {
            return {
                currentPath: SUMMARY_OTHERS,
                exPath: state.currentPath,
            }
        }
        if (action?.type === SUMMARY_ALL) {
            return {
                currentPath: SUMMARY_ALL,
                exPath: state.currentPath,
            }
        }
    }

    // default
    return {
        currentPath: '/',
        exPath: state.currentPath,
    }
}